import React from "react";
import { useGoogleLogin } from "@react-oauth/google";
import { toast } from "react-toastify";
import { updateUserG } from "../../API/userApi";
import { useLoggedInUser } from "../../config/zStore";

// Shooters, editors and managers get the shoots they are on added to their
// Google Calendar (backend utils/calendarSync.js CALENDAR_ROLES).
const CALENDAR_ROLES = ["Shooter", "Editor", "Manager"];

const CalendarIcon = ({ size }) => (
  <svg xmlns="http://www.w3.org/2000/svg" aria-label="Google Calendar" role="img" viewBox="0 0 512 512" width={size} height={size} fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><rect width="512" height="512" rx="15%" fill="#ffffff"></rect><path d="M100 340h74V174H340v-74H137Q100 100 100 135" fill="#4285f4"></path><path d="M338 100v76h74v-41q0-35-35-35" fill="#1967d2"></path><path d="M338 174h74V338h-74" fill="#fbbc04"></path><path d="M100 338v39q0 35 35 35h41v-74" fill="#188038"></path><path d="M174 338H338v74H174" fill="#34a853"></path><path d="M338 412v-74h74" fill="#ea4335"></path><path d="M204 229a25 22 1 1 1 25 27h-9h9a25 22 1 1 1-25 27M270 231l27-19h4v-7V308" stroke="#4285f4" stroke-width="15" stroke-linejoin="bevel" fill="none"></path></g></svg>
);

// The Google Calendar Connect / Connected button. Used in the desktop top bar
// and, with `compact`, in the phone header (the top bar is hidden on phones).
const CalendarConnectButton = ({ compact = false }) => {
  const { userData: currentUser, updateUserData } = useLoggedInUser();

  // Connect Google Calendar. This asks Google for an authorization code
  // rather than a one-hour access token, so the server can keep the calendar
  // connected for a year (see backend utils/googleCalendarAuth.js).
  const loginByGoogle = useGoogleLogin({
    flow: 'auth-code',
    scope: 'https://www.googleapis.com/auth/calendar.events',
    onSuccess: async ({ code }) => {
      try {
        const updatedUser = await updateUserG({ code })
        updateUserData(updatedUser)
      } catch (error) {
        // updateUserG has already shown the reason.
      }
    },
    onError: () => {
      toast.error("Google login was unsuccessful.");
    },
  });

  if (!CALENDAR_ROLES.includes(currentUser?.rollSelect)) return null;

  const size = compact ? 26 : 40;
  const className = `${compact ? "connectGBtn connectGBtn_compact" : "mx-3 connectGBtn"} d-flex align-items-center`;

  if (currentUser.googleConnected) {
    return (
      <div className={className} title="Google Calendar connected">
        Connected <CalendarIcon size={size} />
      </div>
    );
  }
  return (
    <div onClick={loginByGoogle} className={`${className} cursor-pointer`} role="button" title="Connect Google Calendar">
      Connect <CalendarIcon size={size} />
    </div>
  );
};

export default CalendarConnectButton;
